"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var React = require("react");

var tensorFlow = require("@tensorflow/tfjs-core"); // tslint:disable-next-line:no-submodule-imports


var tsne_1 = require("@tensorflow/tfjs-tsne/dist/tsne");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("../component");

var context_1 = require("../context");

var data_1 = require("../data");

var helper_1 = require("../helper");

var TensorTContainerClass =
/** @class */
function (_super) {
  __extends(TensorTContainerClass, _super);

  function TensorTContainerClass(props) {
    var _this = _super.call(this, props) || this;

    _this.canvasContext = null;

    _this.getPlotlyCoordsFromTsne = function (coords) {
      var springContext = _this.props.springContext;
      return [{
        marker: {
          color: _this.props.pointColor
        },
        mode: 'markers',
        type: 'scattergl',
        x: coords.map(function (coord) {
          return coord[0];
        }),
        y: coords.map(function (coord) {
          return coord[1];
        })
      }, {
        marker: {
          color: '#ffaa00'
        },
        mode: 'markers',
        type: 'scattergl',
        x: springContext.currentCells.toArray().map(function (cellIndex) {
          return coords[cellIndex][0];
        }),
        y: springContext.currentCells.toArray().map(function (cellIndex) {
          return coords[cellIndex][1];
        })
      }];
    };

    _this.getPlotlyCoordsFromSpring = function (coords, currentCells) {
      return [{
        marker: {
          color: _this.props.pointColor
        },
        mode: 'markers',
        type: 'scattergl',
        x: coords.map(function (coord) {
          return coord[0];
        }),
        y: coords.map(function (coord) {
          return coord[1];
        })
      }, {
        marker: {
          color: '#ffaa00'
        },
        mode: 'markers',
        type: 'scattergl',
        x: currentCells.map(function (cellIndex) {
          return coords[cellIndex][0];
        }),
        y: currentCells.map(function (cellIndex) {
          return coords[cellIndex][1];
        })
      }];
    };

    _this.getTensorConfigs = function () {
      return [{
        name: 'Iterate Once',
        onClick: _this.onIterateForward(),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
      }, {
        name: 'Iterate Ten Times',
        onClick: _this.onIterateForward(10),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
      }, {
        name: 'Iterate Fifty Times',
        onClick: _this.onIterateForward(50),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
      }, {
        name: 'Reset',
        onClick: _this.onReset(),
        type: data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON
      }, {
        icon: 'hashtag',
        name: "Total Iterations: " + _this.state.numIterations,
        type: data_1.CONFIGURATION_COMPONENT_TYPE.LABEL
      }];
    };

    _this.handlePointSelection = function (event) {
      var springContext = _this.props.springContext;
      var coordsArray = _this.state.coordsArray;
      var selectedCells = new Array();

      var _loop_1 = function _loop_1(i) {
        var x = event.selectedPoints[i];
        var y = event.selectedPoints[i + 1];
        var cellIndex = coordsArray.findIndex(function (coord) {
          return coord[0] === x && coord[1] === y;
        });

        if (cellIndex >= 0) {
          selectedCells.push(cellIndex);
        }
      };

      for (var i = 0; i < event.selectedPoints.length - 1; i += 2) {
        _loop_1(i);
      }

      springContext.setCells(selectedCells);
    };

    _this.renderIterateLabel = function () {
      return React.createElement("label", null, "iterations: " + _this.state.numIterations);
    };
    /**
     * Renders the radio button responsible for toggling the animation on/off.
     */


    _this.renderIterateButton = function () {
      return React.createElement(semantic_ui_react_1.Radio, {
        label: React.createElement("label", {
          style: {
            fontSize: '14px',
            fontWeight: 'bold'
          }
        }, "iterate"),
        onClick: _this.onIterationToggle(),
        toggle: true
      });
    };

    _this.renderResetButton = function () {
      return React.createElement(semantic_ui_react_1.Icon, {
        name: 'undo',
        onClick: _this.onReset()
      });
    };

    _this.onIterateForward = function (amount) {
      if (amount === void 0) {
        amount = 1;
      }

      return function () {
        return __awaiter(_this, void 0, void 0, function () {
          var _a, isComputing, tsne, coordsArray, plotlyCoords;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _a = this.state, isComputing = _a.isComputing, tsne = _a.tsne;
                if (!(tsne && !isComputing)) return [3
                /*break*/
                , 3];
                this.setState({
                  isComputing: true
                });
                return [4
                /*yield*/
                , tsne.iterate(amount)];

              case 1:
                _b.sent();

                return [4
                /*yield*/
                , tsne.coordsArray()];

              case 2:
                coordsArray = _b.sent();
                plotlyCoords = this.getPlotlyCoordsFromTsne(coordsArray);
                this.setState({
                  coordsArray: coordsArray,
                  isComputing: false,
                  numIterations: this.state.numIterations + amount,
                  plotlyCoords: plotlyCoords
                });
                _b.label = 3;

              case 3:
                return [2
                /*return*/
                ];
            }
          });
        });
      };
    };

    _this.onIterationToggle = function () {
      return function () {
        var isAnimating = !_this.state.isAnimating;

        if (isAnimating) {
          var animationFrame_1 = function animationFrame_1() {
            return __awaiter(_this, void 0, void 0, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4
                    /*yield*/
                    , this.onIterateForward(1)()];

                  case 1:
                    _a.sent();

                    if (this.state.isAnimating && this.state.numIterations < 500) {
                      requestAnimationFrame(animationFrame_1);
                    } else {
                      this.setState({
                        isAnimating: false
                      });
                    }

                    return [2
                    /*return*/
                    ];
                }
              });
            });
          };

          requestAnimationFrame(animationFrame_1);
        }

        _this.setState({
          isAnimating: isAnimating
        });
      };
    };

    _this.onReset = function () {
      return function () {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , this.computeTensorTsne(0)];

              case 1:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      };
    };

    _this.state = {
      coordsArray: [],
      isAnimating: false,
      isComputing: false,
      numIterations: 0,
      plotlyCoords: []
    };
    return _this;
  }

  TensorTContainerClass.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var tensorData, tsneData, tsne, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            return [4
            /*yield*/
            , helper_1.fetchTensorTSneCoordinateData("datasets/" + this.props.datasetLocation)];

          case 1:
            tensorData = _a.sent();
            tsneData = tensorFlow.tensor(tensorData);
            return [4
            /*yield*/
            , Promise.resolve().then(function () {
              return require('@tensorflow/tfjs-tsne');
            })];

          case 2:
            tsne = _a.sent().tsne(tsneData);
            this.setState({
              tsne: tsne
            });
            return [4
            /*yield*/
            , this.computeTensorTsne(this.state.numIterations)];

          case 3:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 4:
            e_1 = _a.sent();
            console.log(e_1);
            return [3
            /*break*/
            , 5];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  TensorTContainerClass.prototype.componentDidUpdate = function (prevProps) {
    return __awaiter(this, void 0, void 0, function () {
      var e_2, _a, springContext, tsne, _b, _c, _d, indices, _e, _f, node, _g, _h, _j;

      return __generator(this, function (_k) {
        switch (_k.label) {
          case 0:
            springContext = this.props.springContext;
            tsne = this.state.tsne;
            if (!(this.props.datasetLocation !== prevProps.datasetLocation)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.setupTensorData()];

          case 1:
            _k.sent();

            return [3
            /*break*/
            , 6];

          case 2:
            if (!tsne) return [3
            /*break*/
            , 6];
            if (!(springContext.currentCells !== prevProps.springContext.currentCells)) return [3
            /*break*/
            , 4];
            _b = this.setState;
            _c = {};
            _d = this.getPlotlyCoordsFromTsne;
            return [4
            /*yield*/
            , tsne.coordsArray()];

          case 3:
            _b.apply(this, [(_c.plotlyCoords = _d.apply(this, [_k.sent()]), _c)]);

            return [3
            /*break*/
            , 6];

          case 4:
            if (!!lodash_1.isEqual(springContext.selectedLabels, prevProps.springContext.selectedLabels)) return [3
            /*break*/
            , 6];
            indices = new Array();

            try {
              for (_e = __values(springContext.graphData.nodes), _f = _e.next(); !_f.done; _f = _e.next()) {
                node = _f.value;

                if (springContext.selectedLabels.includes(node.labelForCategory[springContext.selectedCategory])) {
                  indices.push(node.number);
                }
              }
            } catch (e_2_1) {
              e_2 = {
                error: e_2_1
              };
            } finally {
              try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
              } finally {
                if (e_2) throw e_2.error;
              }
            }

            _g = this.setState;
            _h = {};
            _j = this.getPlotlyCoordsFromSpring;
            return [4
            /*yield*/
            , tsne.coordsArray()];

          case 5:
            _g.apply(this, [(_h.plotlyCoords = _j.apply(this, [_k.sent(), indices]), _h)]);

            _k.label = 6;

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  TensorTContainerClass.prototype.render = function () {
    var isFullPage = this.props.isFullPage;
    var plotlyCoords = this.state.plotlyCoords;
    return React.createElement(component_1.ComponentCard, {
      componentName: TensorTContainerClass.displayName,
      iconSrc: 'assets/icons/tfjs-tsne-icon.png',
      isFullPage: isFullPage
    }, React.createElement(semantic_ui_react_1.Grid, {
      centered: true,
      style: {
        height: '100%',
        marginLeft: 0,
        width: '100%'
      }
    }, React.createElement(semantic_ui_react_1.Grid.Row, {
      columns: 'equal',
      style: {
        maxHeight: '23px',
        padding: '7px 0 0 0'
      }
    }, React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'left'
    }, this.renderIterateButton()), React.createElement(semantic_ui_react_1.Grid.Column, null, this.renderIterateLabel()), React.createElement(semantic_ui_react_1.Grid.Column, {
      floated: 'right'
    }, this.renderResetButton())), React.createElement(semantic_ui_react_1.Grid.Row, {
      stretched: true,
      style: {
        height: '90%',
        margin: 0
      }
    }, React.createElement(component_1.TensorTComponent, {
      onSelectedCallback: this.handlePointSelection,
      pointsToPlot: plotlyCoords
    }))));
  };

  TensorTContainerClass.prototype.computeTensorTsne = function (numIterations) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, isComputing, tsne, coordsArray, plotlyCoords;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.state, isComputing = _a.isComputing, tsne = _a.tsne;
            if (!(tsne && !isComputing)) return [3
            /*break*/
            , 3];
            this.setState({
              isComputing: true
            });
            return [4
            /*yield*/
            , tsne.compute(numIterations)];

          case 1:
            _b.sent();

            return [4
            /*yield*/
            , tsne.coordsArray()];

          case 2:
            coordsArray = _b.sent();
            plotlyCoords = this.getPlotlyCoordsFromTsne(coordsArray);
            this.setState({
              coordsArray: coordsArray,
              isComputing: false,
              numIterations: numIterations,
              plotlyCoords: plotlyCoords
            });
            _b.label = 3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  TensorTContainerClass.prototype.setupTensorData = function () {
    return __awaiter(this, void 0, void 0, function () {
      var tensorData, tsneData, tsne, numIterations, coordsArray, plotlyCoords, e_3;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4,, 5]);

            this.setState({
              isAnimating: false,
              isComputing: true,
              plotlyCoords: [],
              tsne: undefined
            });
            return [4
            /*yield*/
            , helper_1.fetchTensorTSneCoordinateData("datasets/" + this.props.datasetLocation)];

          case 1:
            tensorData = _a.sent();
            tsneData = tensorFlow.tensor(tensorData);
            tsne = new tsne_1.TSNE(tsneData);
            numIterations = 0;
            return [4
            /*yield*/
            , tsne.compute(numIterations)];

          case 2:
            _a.sent();

            return [4
            /*yield*/
            , tsne.coordsArray()];

          case 3:
            coordsArray = _a.sent();
            plotlyCoords = this.getPlotlyCoordsFromTsne(coordsArray);
            this.setState({
              coordsArray: coordsArray,
              isComputing: false,
              numIterations: numIterations,
              plotlyCoords: plotlyCoords
            });
            return [3
            /*break*/
            , 5];

          case 4:
            e_3 = _a.sent();
            console.log(e_3);
            return [3
            /*break*/
            , 5];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  TensorTContainerClass.defaultProps = {
    datasetLocation: 'hpc/full',
    height: 400,
    isFullPage: false,
    pointColor: '#aa0000',
    springContext: __assign({}, context_1.initialSpringContext),
    style: {
      padding: 0
    },
    width: 400
  };
  TensorTContainerClass.displayName = 'tSNE - TensorFlow';
  return TensorTContainerClass;
}(React.Component);

exports.TensorTContainerClass = TensorTContainerClass;

exports.TensorTContainer = function (props) {
  return React.createElement(context_1.SpringContext.Consumer, null, function (springContext) {
    return React.createElement(TensorTContainerClass, __assign({}, props, {
      springContext: springContext
    }));
  });
};